import {checkDeliveryNumber, checkEmail} from '../utils/checkAllConfig'

export function checkInput(e) {
    if (e.title === 'Contact name at location' ||
        e.title === 'Contact phone at location' ||
        e.title === 'Email Subject' ||
        e.title === 'Name') {
    } else {
        if (e.inputStyle === 'text' ) {
            if (e.value) {
                e.value = TransferString(e.value)
            }
        }
    }

    if (e.valid) {
        if (e.title === 'Delivery Number') {
            if (e.value) {
                e.isOk = checkDeliveryNumber(e.value)
                e.errorMsg = 'Delivery Number Minimum 10 bits'
            } else {
                e.errorMsg = 'Please enter delivery number'
                e.isOk = false
            }
        } else if (e.title === 'Name') {
            if (e.value) {
                e.isOk = true
            } else {
                e.errorMsg = 'Please enter name'
                e.isOk = false
            }
        } else if (e.title === 'Email') {
            if (e.value) {
                e.errorMsg = 'The mailbox format is incorrect'
                e.isOk = checkEmail(e.value)
            } else {
                e.errorMsg = 'Please enter Email'
                e.isOk = false
            }
        } else {
            if (e.value) {
                e.isOk = true
            } else {
                e.errorMsg = 'Please input a valid value'
                e.isOk = false
            }
        }
    }


    return e
}

function TransferString(content) {
    var string = content;
    try {
        string = string.replace(/\ +/g, "") //去掉空格
        string = string.replace(/[ ]/g, "")   //去掉空格
        string = string.replace(/[\r\n]/g, "")
    } catch (e) {
        // alert(e.message);
    }
    return string;
}
